export default "__VITE_ASSET__DDkrqgls__"